// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2za6K","upload":"Small_upload__BdP7B","imageWrap":"Small_imageWrap__25L2P","removeBtn":"Small_removeBtn__3q0es"};